import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { SearchPagePrefetchedDataProps } from 'src/app/pages/search/pageContext';
import { prefetchPageContext, SearchPageContextProvider } from 'src/app/pages/search/pageContext';

import { Layout } from '../layout';

import { SearchErrorHandler } from './ErrorHandler';

export const Search = withPrefetchedData(
	function Search({ prefetchedData }: SearchPagePrefetchedDataProps) {
		return (
			<SearchPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={SearchErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</SearchPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,

		prefetchData: async (context) => prefetchPageContext(context),
	},
);
